import { config } from '../config'

const intercomAppId = config.analytics.intercom.APP_ID

export default {
  boot: (user: any) => {
    if ('Intercom' in window && intercomAppId) {
      if (!user) {
        Intercom('boot', { app_id: intercomAppId })
      } else {
        Intercom('boot', {
          app_id: intercomAppId,
          email: user.profile.email,
          user_id: user.profile.envato_id,
          user_hash: user.misc.intercom_user_hash,
          created_at: user.profile.created_at
        })
      }
    }
  }
}
